import request from "@/utils/request";
import qs from "qs";
/**
 * 创建菜单【ok】
 * @param params
 * @returns {*}
 */
export function createMenu(params) {
  return request.post("/menu/editMenu", qs.stringify(params));
}

/**
 * 查询角色树【ok】
 * @param params
 * @returns {*}
 */
export function getMenuList(params) {
  return request({
    url: "/menu/getMenuTree",
    method: "get",
    params
  });
}

/**
 * 查询所有的菜单列表【ok】
 * @param params
 * @returns {*}
 */
export function getRoleMenuTree(params) {
  return request({
    url: "/role/getRoleMenuTree",
    method: "get",
    params
  });
}

/**
 * 查询当前用户的菜单列表
 * @param params
 */
// export function getMenuListByCurrentUser(params) {
//   return request({
//     url: "/api/backend/setting/permission/getMenuList",
//     method: "get",
//     params
//   });
// }
